var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"headline"},[_c('span',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('v-btn',{attrs:{"text":"","icon":"","absolute":"","id":"close-button"},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiClose))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }